import axios from 'axios'
import store from '../store/index'
import {REFRESH_TOKEN} from '../store/types'
import storage from './storage.service'

export const CancelToken = axios.CancelToken;

const apiService = {
    axiosInstance: null,
    requestInterceptor: null,
    responseInterceptor: null,
    pending: {},
    isRefreshing: false,
    refreshSubscribers: [],

    init(baseURL) {
        this.axiosInstance = axios.create({baseURL});
    },

    mountResponseInterceptor(){
        this.responseInterceptor = this.axiosInstance.interceptors.response.use(response => {
            return response;
        }, error => {

            if(error.message === 'Network Error'){
                throw {
                    name: 'NetworkError',
                    message: 'A network error occurred...'
                }
            }

            const { config, response: { status } } = error;
            const originalRequest = config;

            if (status === 401) {
                if (!this.isRefreshing ) {
                    this.isRefreshing = true;
                    store.dispatch(REFRESH_TOKEN, storage.getRefreshToken())
                        .then(newToken => {
                            this.isRefreshing = false;
                            this.onRrefreshed(newToken);
                        });
                }

                const retryOriginalRequest = new Promise((resolve, reject) => {
                    this.subscribeTokenRefresh(token => {
                        originalRequest.headers['Authorization'] = token;
                        resolve(axios(originalRequest));
                    });
                });
                return retryOriginalRequest;
            } else {
                return Promise.reject(error);
            }
        });
    },

    subscribeTokenRefresh(cb)  {
        this.refreshSubscribers.push(cb);
    },

    onRrefreshed(token) {
        this.refreshSubscribers.map(cb => cb(token));
    },


    unmountResponseInterceptor() {
        this.axiosInstance.interceptors.response.eject(this.responseInterceptor)
    },


    setAuthHeader() {
        this.axiosInstance.defaults.headers.common["Authorization"] = storage.getToken();
    },


    setHeaders(headers){
        headers.forEach(entry =>{
            this.axiosInstance.defaults.headers.common[entry.header] = entry.value;
        });
    },

    clearHeaders() {
        this.axiosInstance.defaults.headers.common = {};
    },

    sendRequest(request) {
        let headers = [
            {header: 'Culture', value: 'ka-GE'}
        ];
        this.setHeaders(headers);

        return this.axiosInstance({
            url: request.url,
            method: request.method,
            data: request.data,
            params: request.params,
            headers: request.headers,
            cancelToken: request.cancelToken,
        });
    }
};

export default apiService